import { useFormContext } from '@/lib/form-contexts'
import { DetailCell, DetailRow, DetailRows } from '@/components/patterns/detail-rows'
import { Typography } from '@/components/ui/typography'
function DomainRecordTable({ isUpdate, domain, parsedDomain }) {
  const form = useFormContext()

  return (
    <>
      <Typography variant="h5">DNS Records</Typography>
      <Typography variant="supporting">
        Ensure the following DNS records have been added to your domain settings:
      </Typography>
      <DetailRows
        columns={3}
        headers={['Type', 'Name', 'Value']}
        ariaLabel="DNS records"
        className="mt-4"
      >
        {isUpdate && (
          <DetailRow>
            <DetailCell label="Type" className="font-medium">
              TXT
            </DetailCell>
            <DetailCell label="Name">{domain?.txt_name}</DetailCell>
            <DetailCell label="Value" className="break-all">
              {domain?.verification_token}
            </DetailCell>
          </DetailRow>
        )}
        <form.Subscribe selector={(state) => state.values.redirect_apex}>
          {(redirect_apex) => (
            <>
              {(redirect_apex || !parsedDomain?.subdomain) && (
                <DetailRow>
                  <DetailCell label="Type" className="font-medium">
                    A
                  </DetailCell>
                  <DetailCell label="Name">
                    @ <Typography variant="supporting">(or leave blank)</Typography>
                  </DetailCell>
                  <DetailCell label="Value" className="break-all">
                    {import.meta.env.VITE_DNS_IP_ADDRESS}
                  </DetailCell>
                </DetailRow>
              )}
            </>
          )}
        </form.Subscribe>
        {!!parsedDomain?.subdomain && (
          <DetailRow>
            <DetailCell label="Type" className="font-medium">
              CNAME
            </DetailCell>
            <DetailCell label="Name">{parsedDomain?.subdomain}</DetailCell>
            <DetailCell label="Value" className="break-all">
              {import.meta.env.VITE_DNS_URL}
            </DetailCell>
          </DetailRow>
        )}
        {!isUpdate && (
          <DetailRow>
            <DetailCell colSpan={3} className="@[34rem]/detail-rows:col-span-full">
              <Typography variant="supporting">
                There will be one more record after saving...
              </Typography>
            </DetailCell>
          </DetailRow>
        )}
      </DetailRows>
    </>
  )
}
export default DomainRecordTable
